module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./DetailView.js"));
	}, "RelationDetailView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=RelationDetailView!./src/pages/Promote/BusinessHall/AlterRelation/Detail/DetailView.js
// module id = 2076
// module chunks = 367